import { FC } from "react";
import { Button, Loader, Modal, styled } from "@monolith-forensics/monolith-ui";
import { DownloadIcon } from "lucide-react";

interface EvidenceCocReportsModalProps {
  open: boolean;
  onClose: () => void;
  cocReportsData?: {
    filename: string;
    signedUrl: string;
  };
}

const StyledDownload = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

const StyledLoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

export const EvidenceCocReportsModal: FC<EvidenceCocReportsModalProps> = ({
  open,
  onClose,
  cocReportsData,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      showCloseButton={true}
      style={{ maxWidth: "550px", width: "100%" }}
    >
      <Modal.Title>Chain of Custody Reports Export</Modal.Title>
      <div
        style={{
          fontWeight: 500,
          margin: "20px 0px",
          display: "flex",
          flexDirection: "column",
          gap: 10,
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        {!!cocReportsData && (
          <StyledDownload>
            <StyledDownload style={{ marginBottom: 20, marginTop: 20 }}>
              COC Reports Generated...
              <span style={{ fontWeight: 800 }}>{cocReportsData.filename}</span>
            </StyledDownload>
            <a
              href={cocReportsData.signedUrl}
              download={cocReportsData.filename}
            >
              <Button
                variant="contained"
                color="primary"
                size="xs"
                leftSection={<DownloadIcon size={12} />}
              >
                Download
              </Button>
            </a>
          </StyledDownload>
        )}
        {!cocReportsData && (
          <StyledLoadingContainer>
            <Loader />
          </StyledLoadingContainer>
        )}
        {!cocReportsData && <div>Generating COC Reports...</div>}
      </div>
    </Modal>
  );
};
